import React, { useState } from 'react';

import ImageUpload from '../../components/ImageUpload';
import CustomForm from '../../components/CustomForm';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import FixedButton from '../../components/FixedButton';
import useFormInput from '../../hooks/useFormInput';
import BackButton from '../../components/BackButton';
import action from '../../store/action';
import { connect } from 'react-redux';
import { upload } from '../../api/upload';
import { createAccountApi } from '../../api/account';
import config from '../../config';

const options = [
  { value: 'borrowers', label: 'Borrowers' },
  { value: 'managers', label: 'Managers' },
  { value: 'brokers', label: 'Brokers' }
];

function AccountCreate({ global_action_loading, add_account }) {
  const [count, setCount] = useState(0);
  const [file, setFile] = useState();

  const accountName = useFormInput('', count);
  const address = useFormInput('', count);
  const phone = useFormInput('', count);
  const type = useFormInput('borrowers');
  const addAccount = data => {
    createAccountApi(data)
      .then(res => {
        if (res.data.status === 200) {
          data.id = res.data.data;
          add_account(data);
          setCount(count + 1);
          setFile();
          alert('Added Successfully!');
        } else {
          alert(res.data.message);
        }
        global_action_loading(false);
      })
      .catch(err => {
        console.log(err);
        alert('Error');
        global_action_loading(false);
      });
  };
  const submitAccount = () => {
    global_action_loading();
    const data = {
      type: type.value,
      phone: phone.value,
      name: accountName.value,
      address: address.value
    };
    if (file) {
      upload({ file })
        .then(res => {
          const url = config.baseURL + 'uploads/' + res.data.filename;
          return url;
        })
        .then(url => {
          data.logo = url;
          addAccount(data);
        })
        .catch(err => {
          global_action_loading(false);
        });
    } else {
      addAccount(data);
    }
  };

  return (
    <React.Fragment>
      <BackButton path='/account' />

      <ImageUpload file={file} setFile={setFile} />
      <CustomForm>
        <CustomInput {...accountName} label='Name' placeholder='Account Name' required />
        <CustomInput {...address} label='Address' placeholder='Account Address' />
        <CustomInput {...phone} label='Phone' placeholder='Account Phone' />
        <CustomSelect {...type} label='Type' options={options} />
      </CustomForm>
      <FixedButton onClick={submitAccount}>Add Account</FixedButton>
    </React.Fragment>
  );
}

export default connect(null, { ...action.globalLoading, ...action.account })(AccountCreate);
